import { useQuery } from '@tanstack/react-query'
import { api, unwrapFaqList } from '@astro/api'

/** GET /faqs?type=astrology — normalized to the {q, a} shape FaqItem renders. */
export function useFaqs() {
  const query = useQuery({
    queryKey: ['faqs', 'astrology'],
    queryFn: () => api.faqs.list({ type: 'astrology' }),
    select: (res) => unwrapFaqList(res).map(({ question, answer }) => ({ q: question, a: answer })),
  })
  return {
    faqs: query.data ?? [],
    isPending: query.isPending,
    isError: query.isError,
  }
}
